var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('cards-list',{attrs:{"notShowAddButton":false}}),_c('iban-list',{attrs:{"notShowAddButton":!_vm.showSepa}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }